import { render, staticRenderFns } from "./styling.vue?vue&type=template&id=0fe7734b&scoped=true&"
import script from "./styling.vue?vue&type=script&lang=js&"
export * from "./styling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7734b",
  null
  
)

export default component.exports